export default function CasesSection() {
  const cases = [
    {
      icon: 'ri-signal-tower-line',
      industry: '通信事業',
      gradient: 'from-blue-500 to-indigo-600',
      seller: '売却側',
      revenue: '売上高：8億円 / 従業員：45名',
      buyer: '買収側',
      buyerName: '大手通信グループ',
      result: '顧客基盤とインフラを評価され、希望額での成約を実現'
    },
    {
      icon: 'ri-restaurant-line',
      industry: '飲食業',
      gradient: 'from-orange-500 to-red-600',
      seller: '売却側',
      revenue: '売上高：3億円 / 店舗数：8店舗',
      buyer: '買収側',
      buyerName: '外食チェーン大手',
      result: 'ブランド力と立地を評価され、スムーズな事業承継を実現'
    },
    {
      icon: 'ri-code-box-line',
      industry: 'IT・ソフトウェア',
      gradient: 'from-purple-500 to-pink-600',
      seller: '売却側',
      revenue: '売上高：2億円 / 従業員：15名',
      buyer: '買収側',
      buyerName: 'IT企業',
      result: '独自技術と顧客基盤を評価され、創業者の希望条件で成約'
    }
  ];

  return (
    <section className="py-32 bg-gradient-to-b from-slate-50 to-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-40 left-20 w-72 h-72 bg-teal-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-40 right-20 w-72 h-72 bg-cyan-500 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-20">
          <span className="text-teal-600 font-bold text-sm tracking-widest uppercase mb-4 block">
            Success Stories
          </span>
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-6">
            成約事例
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            様々な業種・規模のM&Aをサポートしてきた実績があります
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {cases.map((item, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-transparent hover:-translate-y-2"
            >
              {/* Gradient Glow */}
              <div className={`absolute inset-0 rounded-3xl bg-gradient-to-br ${item.gradient} opacity-0 group-hover:opacity-10 transition-opacity duration-500`}></div>

              <div className="relative z-10">
                {/* Icon */}
                <div className={`w-16 h-16 bg-gradient-to-br ${item.gradient} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 shadow-lg`}>
                  <i className={`${item.icon} text-3xl text-white`}></i>
                </div>

                {/* Industry Badge */}
                <div className="inline-block mb-4">
                  <span className={`px-4 py-2 bg-gradient-to-r ${item.gradient} text-white text-sm font-bold rounded-full`}>
                    {item.industry}
                  </span>
                </div>

                {/* Details */}
                <div className="space-y-3 mb-6">
                  <div className="flex items-start">
                    <div className="w-2 h-2 bg-teal-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <div>
                      <span className="text-xs font-bold text-gray-500 block mb-1">売却側</span>
                      <span className="text-sm text-gray-700">{item.seller}</span>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-2 h-2 bg-cyan-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <div>
                      <span className="text-xs font-bold text-gray-500 block mb-1">買収側</span>
                      <span className="text-sm text-gray-700">{item.buyer}</span>
                    </div>
                  </div>
                </div>

                {/* Result */}
                <div className="pt-6 border-t border-gray-200">
                  <div className="flex items-start">
                    <i className="ri-check-double-line text-teal-600 text-xl mr-2 flex-shrink-0"></i>
                    <p className="text-sm text-gray-700 leading-relaxed font-medium">
                      {item.result}
                    </p>
                  </div>
                </div>
              </div>

              {/* Bottom Gradient */}
              <div className={`absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r ${item.gradient} transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 rounded-b-3xl`}></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
